import { makeStyles } from '@material-ui/core/styles';
import { brand } from '../../themes/howdenTheme';

export const useLandingStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'hidden',
  },
  hero: {
    background: brand.heroBg,
    color: brand.heroText,
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  heroContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  eyebrow: {
    marginTop: theme.spacing(3),
    color: brand.heroText,
    letterSpacing: '0.12em',
    fontWeight: 600,
  },
  heroTitle: {
    color: brand.heroText,
    marginTop: theme.spacing(1),
  },
  heroSubtitle: {
    color: brand.heroText,
    maxWidth: 640,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontWeight: 400,
  },
  signInButton: {
    backgroundColor: brand.ctaBg,
    color: brand.ctaText,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    '&:hover': {
      filter: 'brightness(0.92)',
    },
  },
  heroHelper: {
    marginTop: theme.spacing(2),
    color: brand.heroText,
  },
  errorText: {
    marginTop: theme.spacing(2),
    backgroundColor: 'rgba(0,0,0,0.2)',
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
  },
  section: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  altSection: {
    backgroundColor: brand.subtle,
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  sectionIntro: {
    maxWidth: 720,
    margin: '0 auto',
    marginBottom: theme.spacing(5),
    color: brand.idle,
  },
  cardGrid: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: '100%',
    padding: theme.spacing(1),
  },
  cardIcon: {
    fontSize: 36,
    color: brand.primary,
    marginBottom: theme.spacing(1),
  },
  cardTitle: {
    marginBottom: theme.spacing(1),
  },
  providesBox: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
    backgroundColor: brand.surface,
    border: `1px solid ${brand.border}`,
    borderRadius: theme.shape.borderRadius,
  },
  providesTitle: {
    marginBottom: theme.spacing(2),
  },
  providesItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  providesIcon: {
    color: brand.primary,
    fontSize: 20,
    marginTop: 2,
  },
  footerCta: {
    background: brand.heroBg,
    color: brand.heroText,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  footerTitle: {
    color: brand.heroText,
    marginBottom: theme.spacing(3),
  },
  footerHelper: {
    marginTop: theme.spacing(2),
    color: brand.heroText,
  },
}));
